<template>
  <div class="wrapper1">
    <h3 class="newDetial-title">{{ title }}</h3>
    <p class="newDetial-time">{{ time }}</p>
    <div v-html="this.info" class="info"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: "",
      title: "",
      time: "",
    };
  },
  created() {
    this.getNewInfo({ nid: this.$route.params.id });
  },
  methods: {
    async getNewInfo(params) {
      let res = await this.$api.getNewInfo(params);
      this.info = res.data.data[0].info;
      this.title = res.data.data[0].title;
      this.time = res.data.data[0].stime.split(" ")[0];
    },
  },
};
</script>

<style lang="less">
@media screen and (min-width: 1200px) {
  .wrapper1 {
    padding: 30px;
    min-height: 594px;
    width: 1200px;
    margin: 0 auto;
    .newDetial-title {
      font-size: 20px;
      color: #191919;
      margin-top: 50px;
      line-height: 40px;
      text-align: center;
      font-weight: 400;
    }
    .newDetial-time {
      padding-bottom: 10px;
      border-bottom: 1px solid #ebeaea;
      margin-bottom: 30px;
      text-align: right;
    }
    .info {
        width: 80%;
        margin: 0 auto;
      p {
        line-height: 25px;
        height: auto;
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
      }
      img {
        margin: 15px 110px;
        width: 710px;
        height: auto;           /* 高度自适应，保持比例 */
        display: block;         /* 避免底部间隙 */
      }
      video {
        margin: 0 280px;
        width: 710px;
        height: 400px;
        overflow: hidden;
        border: none;
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .wrapper1 {
    min-height: 5rem;
    width: 3.2rem;
    margin: 0 auto;
    .newDetial-title {
      font-size: 0.12rem;
      color: #191919;
      margin-top: 0.1rem;
      line-height: 0.2rem;
      text-align: center;
      font-weight: 400;
    }
    .newDetial-time {
      padding-bottom: 0.06rem;
      border-bottom: 1px solid #ebeaea;
      margin-bottom: 0.08rem;
      text-align: right;
      font-size: 0.1rem;
    }

    .info {
      p {
        line-height: 0.18rem;
        width: 80%;
        height: auto;
        margin: 0 auto;
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
        font-size: 0.1rem;
      }
      img {
        margin: 0.05rem -0.15rem;
        width: 2.5rem !important;
        height: auto;
        display: block;         /* 避免底部间隙 */
      }
      video {
        margin: 0 0.2rem;
        width: 2.5rem;
        height: 1.5rem;
        overflow: hidden;
        border: none;
      }
    }
  }
}
</style>